"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

var deleteMessage = function deleteMessage(messageId, failureCallback, errorMessage) {
  _axios.default.post('/inbox/delete', _qs.default.stringify({
    messageId: messageId,
    yip_csrf_token: document.getElementById('csrftoken').value
  })).then(function () {
    window.location.reload();
  }).catch(function (res) {
    if (res.response.status === 404) {
      window.location.reload();
    } else {
      failureCallback(errorMessage);
    }
  });
};

var DeletePrivateMessage = function DeletePrivateMessage(_ref) {
  var messageId = _ref.messageId,
      errorCallback = _ref.errorCallback,
      phrases = _ref.phrases;
  return (0, _preact.h)("div", {
    role: "button",
    tabIndex: 0,
    className: "qa-private-message-delete",
    onClick: function onClick() {
      return deleteMessage(messageId, errorCallback, phrases.errorMessage);
    }
  }, phrases.delete);
};

var _default = DeletePrivateMessage;
exports.default = _default;